// extracted by mini-css-extract-plugin
export default {"item":"CardImage_item__pWynr","image":"CardImage_image__rzT41"};